import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";

export const mapVerifyResultToRecord = (result) => ({
  ...result,
  faxReferenceId: result.referenceId ?? result.faxReferenceId ?? "",
});

const getVerifyFailureMessage = (result) =>
  result?.errorMessage ||
  result?.errorReason ||
  "Unable to resolve the provided reference ID.";

export const parseVerifyApiResponse = (responseData) => {
  const payload = responseData?.data ?? responseData;
  const results = Array.isArray(payload?.results) ? payload.results : [];
  const records = [];
  const failures = [];

  results.forEach((result) => {
    if (result?.status === "success") {
      records.push(mapVerifyResultToRecord(result));
      return;
    }

    failures.push({
      referenceId: result?.referenceId,
      message: getVerifyFailureMessage(result),
      result,
    });
  });

  return {
    records,
    failures,
    summary: payload?.summary,
  };
};

export const normalizeVerifyTableRecords = (records, rowIdKey) =>
  records.map((record, index) => ({
    ...record,
    id: record[rowIdKey] ?? record.id ?? `row-${index}`,
  }));

export const buildVerifyApiRequestPayload = ({
  verifyApi,
  verifyInput,
  faxInfoId,
  inputValue,
}) => {
  if (verifyApi?.bodyKey) {
    const value = verifyApi.bodyValueAsArray ? [inputValue] : inputValue;
    return { [verifyApi.bodyKey]: value };
  }

  const paramKey = verifyInput?.paramKey || "searchValue";
  const payload = {
    [paramKey]: inputValue,
  };

  if (verifyApi?.includeFaxInfoId !== false) {
    payload.faxInfoId = faxInfoId;
  }

  if (verifyApi?.extraBody && typeof verifyApi.extraBody === "object") {
    Object.assign(payload, verifyApi.extraBody);
  }

  return payload;
};

export const extractVerifyErrorMessage = (error) =>
  error?.data?.message ||
  error?.statusText ||
  error?.message ||
  "Unable to verify. Please try again.";

export const executeVerifyApiRequest = (verifyApi, requestPayload) => {
  const method = (verifyApi.method || "POST").toUpperCase();

  return new Promise((resolve, reject) => {
    if (method === "GET") {
      const query = new URLSearchParams(
        Object.entries(requestPayload).reduce((acc, [key, val]) => {
          if (val != null && val !== "") acc[key] = String(val);
          return acc;
        }, {})
      ).toString();
      const url = query ? `${verifyApi.url}?${query}` : verifyApi.url;
      sendAuthenticatedAsyncRequest(
        url,
        "GET",
        null,
        (response) => resolve(response.data),
        reject
      );
      return;
    }

    sendAuthenticatedAsyncRequest(
      verifyApi.url,
      method,
      requestPayload,
      (response) => resolve(response.data),
      reject
    );
  });
};
